<div class="panel-group" id="accordion">
  <app-report-detail-section [section]="'attachment'" [title]="'Attachment'" [allExpandState]="allExpandState">
  </app-report-detail-section>
  <div #section id="attachment" class="panel-collapse collapse">
    <app-aa-spinner [loading]="attSummary.isLoading"></app-aa-spinner>
    @if (!attSummary.isLoading) {
      <div class="panel-body ">
        @for (reportAttachment of attSummary.attachments | SortByTimeStampPipe : 'CreatedDate'; track reportAttachment) {
          <div
            class="attachments">
            <div class="attachment-timestamp">
              @if (attSummary.getSubmitterName(reportAttachment)) {
                <span>
                  {{attSummary.getSubmitterName(reportAttachment)}} on
                </span>
                } {{reportAttachment.createdDate | date:'MM/dd/yyyy'}} at
                {{reportAttachment.createdDate | date:'shortTime'}}
              </div>
              <div class="attachment-title">
                <a class="attachment-title"
                (click)="attSummary.viewAttachment(reportAttachment)">{{reportAttachment.fileName}}</a>
              </div>
              <label class="attachment-description">{{reportAttachment.description}}</label>
            </div>
          }
          @if (attSummary.attachments.length <= 0) {
            <label> No Attachment Provided</label>
          }
          @if (!isReportClosed()) {
            <app-add-attachment [employeeId]="responderEmployeeId"
            [descriptionRequired]="true" (onSave)="onSave($event)"> </app-add-attachment>
          }
        </div>
      }
    </div>
  </div>
